import DOMPurify from "dompurify";

const ReceiptPage = ({ html, closePage }) => {
  const handlePrintReceipt = () => {
    window.print();
  };

  return (
    <div className="printReceiptContainer">
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(html),
        }}
      />
      <div className="printReceiptButtonContainer">
        <button
          className="printReceiptButton secondaryButton"
          onClick={closePage}
        >
          Cancel
        </button>
        <button
          className="printReceiptButton primaryButton"
          onClick={handlePrintReceipt}
        >
          Print
        </button>
      </div>
    </div>
  );
};

export default ReceiptPage;
